<template>
  <div class="overflow-auto-">
    <Liste v-if="$route.path.split('/').length<=2"/>
    <router-view v-else></router-view>
  </div>
</template>

<script>
  import Liste from '@/components/Liste'
  export default {
    components: {
      Liste,
    },
    mounted () {
      var p = this.$route.path.split('/');
      if(p[2] && p[2]=='detail')this.header=false;
      else this.header=true;
    },
    watch:{
        $route (to, from){
          var p = this.$route.path.split('/');
          if(p[2] && p[2]=='detail')this.header=false;
          else this.header=true;
        }
    }
  };
</script>